import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { type TAttendanceModalParticipantMark as TMarkState } from "./attendance.modal.ui.types"

export default {
    attendance: {
        body: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "max-w-[95%]",
                "md:max-w-[560px]",
                "w-full",
                "max-h-[90%]",
                "md:min-h-fit",
                "py-[35px]",
                "px-[30px]",
                "bg-white",
                "rounded-[10px]",
                "relative",
                "h-fit"
            ),
        header: (): string => "pb-[8px] flex self-center",
        sessionInfo: {
            container: (): string =>
                buildCssClassName("py-[10px] px-[15px] rounded-[10px] flex items-center gap-x-[15px] w-fit", {
                    "bg-blue-600": import.meta.env.PROD,
                    "bg-blue-400": import.meta.env.DEV
                }),
            timeWrapper: (): string => "flex flex-col md:flex-row items-start md:items-center md:gap-x-[5px]"
        },
        container: {
            container: (): string => "flex flex-col gap-y-[40px]",
            wrapper: (): string => "flex flex-col gap-y-[30px]",
            notPresenceWarning: (): string => "flex flex-col gap-y-[10px] mx-auto",
            notPresenceWarningDescription: (): string => "md:max-w-[370px]",
            participants: {
                wrapper: ({ isScrollDisabled, isLocked }: { isScrollDisabled?: boolean; isLocked: boolean }): string =>
                    buildCssClassName(
                        "relative",
                        "max-h-[220px]",
                        "md:max-h-[400px]",
                        "no-scrollbar",
                        { "overflow-y-hidden": isScrollDisabled },
                        { "overflow-y-auto": !isScrollDisabled },
                        { "pointer-events-none": isLocked },
                        "overscroll-contain",
                        "touch-auto",
                        "flex",
                        "flex-col",
                        "gap-y-[10px]"
                    ),
                item: {
                    container: (): string =>
                        buildCssClassName("pb-[12px] flex flex-col gap-y-[10px] border-b-[1px]", {
                            "border-blue-500": import.meta.env.PROD,
                            "border-blue-300": import.meta.env.DEV
                        }),
                    header: (): string => "flex gap-x-[10px] items-center",
                    headerName: (): string =>
                        "flex flex-col md:flex-row gap-y-[5px] md:gap-y-0 md:gap-x-[5px] items-start md:items-end",
                    bodyContainer: (): string => "flex flex-col gap-y-[10px]",
                    bodyWrapper: (): string => "flex gap-x-[15px] min-h-[37px] h-fit items-start",
                    marks: (): string => "flex items-center gap-x-[5px] mt-[3px]",
                    mark: ({ isSelected, state }: { isSelected: boolean; state: TMarkState }): string =>
                        buildCssClassName(
                            "h-[30px]",
                            "w-[30px]",
                            "rounded-[30px]",
                            "flex",
                            "!outline-none",
                            "select-none",
                            "items-center",
                            "justify-center",
                            "border-[1px]",
                            "border-white",
                            { "bg-gray-500": !isSelected },
                            [
                                state === "present" && [
                                    isSelected
                                        ? "bg-green-200"
                                        : {
                                              "hover:bg-green-400 focus-visible:bg-green-400": import.meta.env.PROD,
                                              "hover:bg-green-300 focus-visible:bg-green-300": import.meta.env.DEV
                                          }
                                ]
                            ],
                            [
                                state === "not_present" && [
                                    isSelected
                                        ? "bg-red-200"
                                        : {
                                              "hover:bg-red-400 focus-visible:bg-red-400": import.meta.env.PROD,
                                              "hover:bg-red-300 focus-visible:bg-red-300": import.meta.env.DEV
                                          }
                                ]
                            ],
                            getTransitionTwClasses("all", 200)
                        ),
                    filler: (): string =>
                        buildCssClassName("h-[37px] w-full rounded-[10px]", {
                            "bg-blue-400": import.meta.env.DEV,
                            "bg-blue-600": import.meta.env.PROD
                        }),
                    selects: ({ isOneCol }: { isOneCol: boolean }): string =>
                        buildCssClassName(isOneCol ? "w-full" : "grid grid-cols-2 gap-x-[10px] w-full items-start"),
                    tagsSelect: (): string => "flex flex-col gap-y-[5px]"
                }
            }
        }
    },
    earlyAttendance: {
        body: (): string =>
            buildCssClassName(
                "flex",
                "flex-col",
                "max-w-[95%]",
                "md:max-w-[620px]",
                "w-full",
                "max-h-[90%]",
                "md:min-h-fit",
                "py-[35px]",
                "px-[30px]",
                "bg-white",
                "rounded-[10px]",
                "relative",
                "h-fit"
            ),
        header: (): string => "pb-[8px]",
        container: (): string => "flex flex-col gap-y-[40px] items-center",
        middleWrapper: (): string => "flex flex-col gap-y-[8px]"
    }
} as const
